"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicenseFileTypeSchema = exports.LicenseFileType = exports.IPTypeSchema = exports.IPType = void 0;
const zod_1 = require("zod");
var IPType;
(function (IPType) {
    IPType["PATENT"] = "PATENT";
    IPType["COPYRIGHT"] = "COPYRIGHT";
    IPType["TRADE_SECRETS_KNOW_HOW"] = "TRADE_SECRETS_KNOW_HOW";
    IPType["TRADEMARK"] = "TRADEMARK";
    IPType["DESIGNS"] = "DESIGNS";
    IPType["PLANT_BREEDERS_RIGHTS"] = "PLANT_BREEDERS_RIGHTS";
    IPType["OTHER"] = "OTHER";
})(IPType || (exports.IPType = IPType = {}));
/**
 * Zod schema for validating and parsing case action values.
 *
 * - Ensures that a given input is a valid IPType value.
 * - Can be used in request validation (e.g. with ZodValidationPipe in NestJS).
 *
 */
exports.IPTypeSchema = zod_1.z.nativeEnum(IPType);
var LicenseFileType;
(function (LicenseFileType) {
    LicenseFileType["DUE_DILIGENCE"] = "DUE_DILIGENCE";
    LicenseFileType["LICENSE_AGREEMENT"] = "LICENSE_AGREEMENT";
    LicenseFileType["OTHER"] = "OTHER";
})(LicenseFileType || (exports.LicenseFileType = LicenseFileType = {}));
exports.LicenseFileTypeSchema = zod_1.z.nativeEnum(LicenseFileType);
